import React from "react";

const RoadMap = () => {
    return (
        <>
            <div className="roadMap">
                <div className="hRoad">ROAD MAP</div>
                <div className="imgDiv">
                    <img alt="img1" src="/Image/DALL·E 2024-07-14 21.37.17 - A 3D cartoon illustration of a very happy furry Central Asian Shepherd dog in explorer attire, standing at a crossroads and holding a map with a yello 2.png" className="img1" />
                    <div className="imgShadowDiv">
                    <img alt="img1" src="/Image/DALL·E 2024-07-14 21.37.17 - A 3D cartoon illustration of a very happy furry Central Asian Shepherd dog in explorer attire, standing at a crossroads and holding a map with a yello 2.png" className="img2" />
                </div>
                </div>
                <div className="info">
                    Our journey is just beginning. Explore our roadmap to see the exciting milestones and future plans we have in store.
                    <br/><span>Join us as we grow and achieve new heights.</span>
                </div>
                <div className="service">
                    <div className="div1">
                        <div>
                        Community   Building 
                       <br/> <span>and Initial Launch</span>
                        </div>
                        <div className="imgDiv1">
                            <img alt="img1" className="img1" src="/Image/DALL·E 2024-07-15 01.28.43 - A full body 3D cute cartoon illustration of a very happy furry Central Asian Shepherd dog dressed as a construction worker. The dog should have a big_ 3.png"/>
                        </div>
                        </div>
                    <div className="div2">
                    <div>
                    Merchandise 
                       <br/> <span>Store Launch</span>
                        </div>
                        <div className="imgDiv2">
                            <img alt="img2" className="img2" src="/Image/DALL·E 2024-07-15 01.31.03 - A full-body 3D cute cartoon illustration of a very happy furry Central Asian Shepherd dog dressed in a t-shirt with an Alabay dog printed on it and we 2.png"/>
                        </div>
                    </div>
                    <div className="div3">
                    <div>
                    Community Events
                       <br/> <span>and contests</span>
                        </div>
                        <div className="imgDiv3">
                            <img alt="img3" className="img3" src="/Image/DALL·E 2024-07-15 01.32.53 - A full-body 3D cute cartoon illustration of a very happy furry Central Asian Shepherd dog celebrating with a trophy. The dog should have a big smile a 1.png"/>
                        </div>
                    </div>
                    <div className="div4">
                    <div>
                    Expansion <br/> and New
                       <br/> <span>Features</span>
                        </div>
                        <div className="imgDiv4">
                            <img alt="img4" className="img4" src="/Image/DALL·E 2024-07-15 01.33.29 - A full-body 3D cute cartoon illustration of a very happy furry Central Asian Shepherd dog dressed in a Viking outfit. The dog should have a big smile_ 1.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RoadMap;
